export default __webpack_public_path__ + "static/media/add-card.14519641.png";